export default {
      id: "alerts-usage",
      viewBox: "0 0 38 38",
      url: __webpack_public_path__ + "img/icons.svg#alerts",
      toString: function () {
        return this.url;
      }
    }